import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SettingDto } from '../../models/request.dto';
import { RequestService } from '../../services/request.service';
import { DesignAngularKitModule, ItNotificationService, NotificationPosition } from 'design-angular-kit';
import { FormsModule } from '@angular/forms';
import { FormDto } from '../../models/form.dto';

@Component({
  selector: 'app-models',
  standalone: true,
  imports: [DesignAngularKitModule,
    FormsModule,
    CommonModule,],
  templateUrl: './models.component.html',
  styleUrl: './models.component.scss'
})
export class ModelsComponent {

  settings: SettingDto[] = [];
  selectedSetting: any | undefined;
  forms: FormDto[] | undefined;

  constructor(
    private requestService: RequestService,
    private notification: ItNotificationService
  ) { }

  ngOnInit(): void {
    this.getSettings();
  }

  getSettings() {
    this.requestService
      .getAllSettings()
      .subscribe((response) => {
        if (response) {
          this.settings = response as SettingDto[];
        }
      });
  }

  onSelectedSetting() {
    this.getFormsForSetting();
  }

  getFormsForSetting() {
    this.requestService.getFormsForSetting(this.selectedSetting).subscribe((response) => {
      if (response) {
        this.forms = response as FormDto[];
      }
    });
  }

  print(form: FormDto) {
    if (form.printCode) {
      this.requestService.print(form!.printCode).subscribe((result) => {
        const mimeType = 'application/pdf';
        const fileBlob = new Blob([result], { type: mimeType });

        const objectUrl = URL.createObjectURL(fileBlob);
        const printWindow = window.open(objectUrl, '_blank');

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
          };
        }
      }
      );
    } else {
      this.notification.warning(
              'Attenzione.',
              'Impossibile stampare il modulo richiesto.',
              true,
              3000,
              NotificationPosition.Top
            );
            return;
    }
  }
}
